<template>
  <div>
    <h2>All Reviews for Manuscript</h2>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>